import * as Sqrl from 'squirrelly';
import type { IndexResult, AlgoliaResultHit } from '../interface';

const squirrel = Sqrl;

squirrel.filters.define(
  'date_long',
  (
    str: string,
    options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }
  ) => {
    if (!str) return;
    const date = new Date(parseInt(str) * 1000);
    str = date.toLocaleDateString('en-GB', options);
    return str;
  }
);

squirrel.filters.define(
  'date_short',
  (str: string, format: string = 'd/m/y') => {
    if (!str) return;
    const date = new Date(parseInt(str) * 1000);
    str = format.replace(/(d)/, date.getDate().toString());
    str = str.replace(/(m)/, (date.getMonth() + 1).toString());
    str = str.replace(/(y)/, date.getFullYear().toString());
    return str;
  }
);

squirrel.filters.define('public_name', (str: string) => {
  if (!str) return;
  str = str
    .split('_')
    .map((val) => {
      return val.length < 3 ? val.toUpperCase() : val;
    })
    .join(' ');
  return str.charAt(0).toUpperCase() + str.slice(1);
});

squirrel.filters.define('trim_to', (str: string, length: number = 100) => {
  if (!str) return;
  if (str.length <= length) return str;
  return str.substr(0, length) + '...';
});

squirrel.filters.define('classname', (str: string) => {
  if (!str) return;
  return str.replace(/[\W]+/g, '');
});

squirrel.filters.define(
  'abs_url',
  (str: string, index: IndexResult = null, result?: AlgoliaResultHit) => {
    if (!index) return str;
    if (!str) return;

    let domain = undefined;
    if (index.domains && result && result.origin) {
      const found = index.domains.find((dm) => dm.origin === result.origin);
      domain = found ? found.domain : '';
    } else if (index.domain) domain = index.domain;

    if (!domain) return str;
    return str.match(/^http/) ? str : location.protocol + '//' + domain + str;
  }
);

squirrel.filters.define(
  'replace',
  (str: string, search?: string, replace?: string) =>
    str.replace(search, replace)
);
squirrel.filters.define('remove_spaces', (str: string) =>
  str.replace(/ /g, '_')
);
squirrel.filters.define(
  'add_spaces',
  (str: string) => (str = str.replace(/[_\-]/g, ' '))
);
squirrel.filters.define(
  'capitalise',
  (str: string) => (str = str.charAt(0).toUpperCase() + str.slice(1))
);
squirrel.filters.define(
  'lowercase',
  (str: string) => (str = str.toLowerCase())
);

export const Squirrel = squirrel;
